/*
 *  Class MobileMenu
 */
export
default class MobileMenu {
    constructor() {
        this.menuBtnOpen = document.querySelector('.open-mobile-menu');
        this.menuBtnClose = document.querySelector('.mobile-menu__close');
        this.accordionContainer = document.querySelector('.mobile-menu__nav-item');
        this.accordionItems = document.querySelectorAll('.mobile-menu__nav-item > .menu-item');
        this.body = document.querySelector('body');
    }

    showMenu(e) {
        e.preventDefault();
        this.body.classList.add('mm-visible');
    }

    hideMenu(e) {
        e.preventDefault();
        this.body.classList.remove('mm-visible');
    }

    openAccordion(item) {
        const isOpened = item.classList.contains('menu-item--opened');
        this.accordionItems.forEach(item => item.classList.remove('menu-item--opened'));
        if (!isOpened) item.classList.add('menu-item--opened');
    }

    init() {
        this.menuBtnOpen.addEventListener('click', this.showMenu.bind(this));
        this.menuBtnClose.addEventListener('click', this.hideMenu.bind(this));
        this.accordionContainer.addEventListener('click', event => {
            if (event.target.closest('.mobile-menu__nav-item > .menu-item > .menu-link')) {
							const menuItem = event.target.closest('.menu-item');
							const submenu = menuItem && menuItem.querySelector('.sub-menu');

							if (submenu) {
								event.preventDefault();
								event.stopPropagation();
								this.openAccordion(event.target.closest('.menu-item'));
							}
            }
        });
    }
}
